import React, { useCallback } from 'react';
import { Form } from '../../../ui/form/components/form';
import { useForm } from '../../../contexts/form-context';
import { useFieldValidation } from '../../../contexts/field-validation-context';
import { useFormFields } from '../../../ui/form/contexts/form-fields-context';
import { useFieldActions } from '../../../contexts/field-actions-context';
const NO_VALUES = {};
const NO_ERRORS = [];
const FullName = _ref => {
  let {
    id,
    form,
    value,
    onChange,
    errors,
    FieldLayout
  } = _ref;
  const formSchema = useForm();
  const {
    validateFields
  } = useFieldValidation();
  const fields = useFormFields();
  const fieldActions = useFieldActions();
  const handleFieldChange = useCallback((target, subFieldValue) => {
    onChange == null || onChange({
      ...value,
      [target]: subFieldValue
    });
  }, [onChange, value]);
  if (!form) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(Form, {
    formSchema: formSchema,
    form: form,
    values: value ?? NO_VALUES,
    onFieldChange: handleFieldChange,
    errors: errors ?? NO_ERRORS,
    validateFields: validateFields,
    fields: fields,
    fieldActions: fieldActions
  }));
};
export default FullName;
//# sourceMappingURL=full-name.js.map